module.exports = __webpack_public_path__ + "static/img/lun_5.2d915c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lun_5.jpg
// module id = uxMs
// module chunks = 1